<template>
    <div class="d-print-none" v-if="datap">
        <DAToolbar :data="{toolbar}" />
    </div>

    <div class="page-header d-none d-print-block">
        <div class="row">

            <div class="p-0 col-12 col-sm-8 d-inline-flex flex-row align-items-center">
                <img src="/assets/images/logo.png" width="50" />
                <div class="headerLeft ms-4" v-html="G.projectSubtitle"></div>
            </div>
            <div class="p-0 col-12 col-sm-4 d-inline-flex justify-content-end align-items-center">
                <!-- {{ TR.print_date }}: {{ moment.utc().tz(G.systemData?.timezone?.value).format(G.datetime_format['for_print']) }} -->
                <div class="row w-100">
                    <div class="col-12 d-inline-flex justify-content-end">
                        {{ TR.print_date }}: {{ G.dateToStr(moment().format(G.datetime_format['datetime_as_pg']), 'for_print') }}
                        <!-- {{ TR.print_date }}: {{ moment.utc().tz(G.systemData?.timezone?.value).format(G.datetime_format['for_print']) }} -->
                    </div>
                    <div class="col-12 d-inline-flex justify-content-end fw-bold">
                        {{ page_title }}
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- <div class="page-footer d-none d-print-block me-4">
        I'm The Footer
    </div> -->

    <table>

        <thead>
            <tr>
                <td>
                    <div class="page-header-space d-none d-print-block"></div>
                </td>
            </tr>
        </thead>

        <tbody>
            <tr>
                <td>
                    <div class="page">
                        <keep-alive>
                            <component class="print_page" @load="window.print();" :is="loadedComponents" v-model:mainref="search_ref" :data="datap"></component>
                        </keep-alive>
                    </div>
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr>
                <td>
                    <div class="page-footer-space d-none d-print-block"></div>
                </td>
            </tr>
        </tfoot>

    </table>

</template>


<script>
import { ref, onBeforeMount, defineAsyncComponent, shallowRef, onMounted, watchEffect } from 'vue';
import { useStore } from '@/system_modules/store';
import { useRoute } from 'vue-router';

import moment from 'moment-timezone';

import DAToolbar from "@/components/toolbar/DAToolbar";

import { G } from '@/_common';

export default {
    title: "print",
    name: "PrintP",
    props:{
        data:{
            type: Object,
            default: () => {}
        }
    },
    components: {
        DAToolbar,
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const datap = ref({});
        const search_ref = ref({});
        const loadedComponents = shallowRef({});
        const TR = ref();
        const toolbar = ref();
        const page_title = ref("");
        const page_orien = ref('portrait');

        const tables = {
            persons: {
                name: "persons", page: "persons/ViewPersons"
            },
            informations: {
                name: "informations", page: "informations/ViewInformations"
            },
            information_bank: {
                name: "information_bank", page: "information_bank/ViewInformationBank"
            },
            border_violator: {
                name: "border_violator", page: "border_violator/ViewBorderViolator"
            },
            signals: {
                name: "signals", page: "signals/ViewSignals"
            },
            eki_baza: {
                name: "eki_baza", page: "eki_baza/ViewEkiBaza"
            },
            amas_baza: {
                name: "amas_baza", page: "amas_baza/ViewAmasBaza"
            },
            info_baza: {
                name: "info_baza", page: "info_baza/ViewInfoBaza"
            },
            eqi_baza: {
                name: "eqi_baza", page: "eqi_baza/ViewEqiBaza"
            },
        };

        watchEffect(() => {
            TR.value = store.getTranslation();
            page_title.value = TR.value[tables[route.params.page].name];

            toolbar.value = {
                class: "p-3",
                leftSide: {
                    buttons: [
                        {
                            label: TR.value.close,
                            icon: "fas fa-times",
                            class: "btn-secondary",
                            eventCallback: () => {
                                window.close();
                            },
                        },
                        {
                            label: TR.value.print,
                            icon: "fas fa-print",
                            class: "btn-primary",
                            eventCallback: async () => {
                                window.print();
                            },
                        },
                    ],
                },
            };
        });

        const loadComponent = async (name) => {
            let tab_page = tables[name].page;
            if( name == 'border_violator' ){
                page_orien.value = 'landscape';
            }

            loadedComponents.value = defineAsyncComponent({
                loader: () => import(`@/pages/${tab_page}`).then(
                    (mod) => {
                        return mod;
                    },
                    () => {
                        return import('@/system_modules/NotFound');
                    }
                ),
                loadingComponent:
                    '<center><i class="fa fa-sync fa-spin"></i></center>',
                errorComponent:
                    defineAsyncComponent(() =>
                        import('@/system_modules/NotFound')
                    ),
                suspensible: false,
            });
        };

        datap.value = {data: {id: route.params.id}};

        onBeforeMount(async () => {
            await loadComponent(route.params.page);
        });

        onMounted(() => {
            setTimeout(() =>
                window.print()
            , 1000);
        });

        return {
            G,
            TR,
            moment,
            datap,
            search_ref,
            loadedComponents,
            toolbar,
            page_orien,
            page_title,
        };
    },
}
</script>

<style lang="scss">
body{
    background-color: #ffffff;
}
table{
    width: 100%;
}
.page {
    // page-break-before: always;
    // break-before: always;
}
.page-header, .page-header-space {
  height: 60px;
}
.page-footer, .page-footer-space {
  height: 20px;
}
.page-header {
    position: fixed;
    top: 0mm;
    width: 100%;
    border-bottom: 1px solid #adadad; /* for demo */
}
.page-footer {
    position: fixed;
    bottom: 0;
    text-align: end;
    width: 100%;
    border-top: 1px solid #adadad; /* for demo */
    // counter-increment: page;
}

// @page:first {
//     @bottom-right {
//         content: normal;
//         margin: 0;
//     }

//     @bottom-left {
//         content: normal;
//         margin: 0;
//     }
// }
// @page:right{
//     @bottom-left {
//         margin: 10pt 0 30pt 0;
//         border-top: .25pt solid #666;
//         content: "Our Cats";
//         font-size: 9pt;
//         color: #333;
//     }

//     @bottom-right {
//         margin: 10pt 0 30pt 0;
//         border-top: .25pt solid #666;
//         content: counter(page);
//         font-size: 9pt;
//     }

//     @top-right {
//         content:  'string(doctitle)';
//         margin: 30pt 0 10pt 0;
//         font-size: 9pt;
//         color: #333;
//     }
// }
// @page:left {
//     @bottom-right {
//         margin: 10pt 0 30pt 0;
//         border-top: .25pt solid #666;
//         content: "Our Cats";
//         font-size: 9pt;
//         color: #333;
//     }

//     @bottom-left {
//         margin: 10pt 0 30pt 0;
//         border-top: .25pt solid #666;
//         content: counter(page);
//         font-size: 9pt;
//     }
// }

// @page:right{
//   @bottom-left {
//     margin: 10pt 0 30pt 0;
//     border-top: .25pt solid #666;
//     font-size: 9pt;
//     color: #333;
//     // content: "My book";
// //   }
// // }
// // @page:right{
// //   @bottom-right {
//     counter-increment: page;
//     content: counter(page);
//   }
// }

// @page:left{
//   @bottom-left {
//     margin: 10pt 0 30pt 0;
//     border-top: .25pt solid #666;
//     font-size: 9pt;
//     color: #333;
//     counter-increment: page;
//     content: counter(page);
//   }
// }


// .page-footer::after {
//     content: counter(page);
// }

// @page {
//     size: A4 v-bind(page_orien);
//     margin: 10mm 10mm 10mm 20mm;
//     -moz-margin-start: 1cm;
//     -moz-margin-end: 1cm;

//     @bottom-left {
//         content: "DSX";
//     }
//     @bottom-right {
//         content: "Page " counter(page);
//     }
// }

// // @page {
// //     size: A4 v-bind(page_orien);
// //     margin: 10mm 10mm 10mm 20mm;

// //     // counter-increment: page;
// //     counter-reset: page;
// //     page-break-after: always;
// //     break-after: always;
// //     // @bottom-right {
// //     //     content: counter(page);
// //     // }
// //     // @bottom-center {
// //     //     content: counter(page);
// //     //     font-family: Arial, sans-serif;
// //     //     font-size: 10pt;
// //     // }
// // }

// @media print {
//     * {
//         -moz-print-color-adjust: exact !important;
//     }
//     thead { display: table-header-group; }
//     tfoot { display: table-footer-group; }
//     // body { margin: 0mm; }

//     .row, .col-12, .card, .card-body{
//         margin: 0;
//         padding: 0;
//     }
//     // body {
//     //     counter-reset: page;
//     // }

//     // @page {
//     //     @bottom-right {
//     //         content: "Page " counter(page) " of " counter(pages);
//     //     }
//     // }
//     // .page-footer::after {
//     //     // content: counter(page);
//     //     content: "Page " counter(page) " of " counter(pages);
//     // }
// }
// body{
//     counter-increment: page;
// }


@page {
    size: A4;
    margin: 10mm 10mm 10mm 20mm;

    // counter-reset: page 1;
    // counter-increment: page;

    // @-moz-document url-prefix() {
    //     margin-top: 2cm;
    //     margin-bottom: 2cm;
    // }

    @bottom-right {
        font-size: 10pt;
        font-family: Arial, sans-serif;
        content: counter(page);
    }
}

/* Fallback for Firefox when @page rules don't work */
@media print {
    * {
        -moz-print-color-adjust: exact !important;
    }
    thead { display: table-header-group; }
    tfoot { display: table-footer-group; }

    .row, .col-12, .card, .card-body{
        margin: 0;
        padding: 0;
    }

    body::after {
        // -moz-print-content: page;
        content: counter(page);
        counter-increment: page;
        position: fixed;
        bottom: 0;
        right: 0;
        margin-right: 10px;
        font-size: 10pt;
        display: none; /* Hidden by default */
    }

    @-moz-document url-prefix() {
        body::after {
            display: block;
        }
    }
}

// @media print {

//   /* If you need to exclude some elements from incrementing the counter */
//   .no-page-count {
//     page-break-after: always;
//     counter-increment: none;
//   }
// }

</style>